import React, { useContext } from 'react'
import './index.scss'
import { ICONS } from '@Const/common'
import { publishersCounter } from '@App/helpers/publishers-counter'
import { StoresContext } from '@App/contexts'
import clsx from 'clsx'

interface WorkRegistrationWizardRoadProps {
    currentStep: number | string
    onlyOneStep?: boolean
}

const WorkRegistrationWizardRoad = (props: WorkRegistrationWizardRoadProps) => {
    const { workStore } = useContext(StoresContext)
    const { currentStep, onlyOneStep } = props
    const workDraft = workStore.workDraftLocal

    return (
        <div className={clsx(`wizard-road-component current-step-${currentStep}`, onlyOneStep && 'only-one')}>
            <div className="wizard-step step-details">
                <img src={ICONS.workDetails} alt="Details" />
                <span>Details</span>
            </div>
            <div className="wizard-step step-writers">
                <img src={ICONS.writers} alt="Writers" />
                <span data-count={`(${workDraft ? workDraft.writers.length : 0})`}>Writers</span>
            </div>
            <div className="wizard-step step-details">
                <img src={ICONS.publishers} alt="Publishers" />
                <span data-count={`(${workDraft ? publishersCounter(workDraft.originalPublishers) : 0})`}>
                    Publishers
                </span>
            </div>
            <div className="wizard-step step-details">
                <img src={ICONS.recording} alt="Recordings" />
                <span data-count={`(${workDraft ? workDraft.recordings.length : 0})`}>Recordings</span>
            </div>
            <div className="wizard-step step-details">
                <img src={ICONS.review} alt="Review" />
                <span>Review</span>
            </div>
        </div>
    )
}

export default WorkRegistrationWizardRoad
